/*
 * This file is part of ng2-json-editor.
 * Copyright (C) 2016 CERN.
 *
 * ng2-json-editor is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License as
 * published by the Free Software Foundation; either version 2 of the
 * License, or (at your option) any later version.
 *
 * ng2-json-editor is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with ng2-json-editor; if not, write to the Free Software Foundation, Inc.,
 * 59 Temple Place, Suite 330, Boston, MA 02111-1307, USA.
 * In applying this license, CERN does not
 * waive the privileges and immunities granted to it by virtue of its status
 * as an Intergovernmental Organization or submit itself to any jurisdiction.
*/

import {
  Component,
  Input,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnChanges,
  SimpleChanges,
  TemplateRef
} from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';

import { Observable } from 'rxjs/Observable';

import { AppGlobalsService, PathUtilService } from '../shared/services';
import { RefConfig, JSONSchema, RefAnchorAttributes } from '../shared/interfaces';


export class RefFieldComponent implements OnChanges {

   schema: JSONSchema;
   value: Map<string, string>;
   path: Array<any>;

  pathString: string;
  refData: object;
  requestOptions: RequestOptions;
  refPath: Array<any>;

  isPreviewButtonHidden = false;

  private anchorAttributes: RefAnchorAttributes;

  constructor(private http: Http,
    private changeDetectorRef: ChangeDetectorRef,
    private appGlobalsService: AppGlobalsService,
    private pathUtilService: PathUtilService) { }

  ngOnChanges(changes: SimpleChanges) {
    if (this.refConfig) {
      const valueChange = changes['value'];
      const schemaChange = changes['schema'];

      if (valueChange && this.refConfig && this.refConfig.anchorBuilder && this.ref) {
        this.anchorAttributes = this.refConfig.anchorBuilder(this.ref);
      }

      // instead of ngOnInit because requestOptions has to be set before fetching
      if (schemaChange && schemaChange.isFirstChange()) {
        this.requestOptions = this.createRequestOptionsWithConfig();
      }

      if (valueChange && this.isTemplateEnabled) {
        if (this.refConfig.lazy) {
          this.isPreviewButtonHidden = false;
        } else {
          this.fetchRef();
        }
      }
    }

    if (changes['path']) {
      this.pathString = this.pathUtilService.toPathString(this.path);
      this.refPath = this.path.concat('$ref');
    }
  }

  onPreviewClick() {
    this.isPreviewButtonHidden = true;
    this.fetchRef();
  }

  get customTemplate(): TemplateRef<any> {
    return this.appGlobalsService.templates[this.refConfig.templateName];
  }

  get refConfig(): RefConfig {
    return this.schema.refFieldConfig;
  }

  get ref(): string {
    return this.value.get('$ref');
  }

  get anchorHref(): string {
    return this.anchorAttributes ? this.anchorAttributes.href : this.ref;
  }

  get anchorDisplay(): string {
    return this.anchorAttributes ? this.anchorAttributes.display : this.ref;
  }

  get isTemplateEnabled(): boolean {
    return this.refConfig !== undefined && this.refConfig.templateName !== undefined;
  }

  get shouldDisplayTemplate(): boolean {
    return this.isPreviewButtonHidden || !this.refConfig.lazy;
  }

  get shouldDisplayInputField(): boolean {
    return this.refConfig !== undefined && this.refConfig.displayInputField;
  }

  private fetchRef() {
    this.refData = undefined;
    this.http
      .get(this.ref, this.requestOptions)
      .map(res => res.json())
      .catch(error => {
        return Observable.of({ $error: error });
      }).subscribe(data => {
        this.refData = data;
        this.changeDetectorRef.markForCheck();
      });
  }

  private createRequestOptionsWithConfig(): RequestOptions {
    const headers = new Headers();
    if (this.refConfig.headers) {
      this.refConfig.headers
        .forEach(header => headers.append(header.name, header.value));
    }
    return new RequestOptions({ headers });
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'ref-field',
  styles: ["button.btn-preview-template { background: transparent; border: 0; width: 100%; height: 100%; } .align-center { width: 100%; text-align: center; } .break-word { word-break: break-word; } "],
  template: "<div [id]=\"pathString\"> <div *ngIf=\"shouldDisplayInputField\"> <primitive-field [value]=\"ref\" [schema]=\"schema['properties']['$ref']\" [path]=\"refPath\"></primitive-field> </div> <div *ngIf=\"ref\"> <div *ngIf=\"isTemplateEnabled\"> <button class=\"btn-preview-template\" *ngIf=\"!shouldDisplayTemplate\" (click)=\"onPreviewClick($event)\"><i class=\"fa fa-eye\"></i></button> <div *ngIf=\"shouldDisplayTemplate\"> <ng-template *ngIf=\"refData\" [ngTemplateOutlet]=\"customTemplate\" [ngTemplateOutletContext]=\"{response: refData}\"></ng-template> <i *ngIf=\"!refData\" class=\"fa fa-spinner fa-spin align-center\"></i> </div> </div> <div *ngIf=\"!isTemplateEnabled\"> <a target=\"_blank\" class=\"break-word\" [href]=\"anchorHref\">{{anchorDisplay}}</a> </div> </div> </div> ",
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Http, },
{type: ChangeDetectorRef, },
{type: AppGlobalsService, },
{type: PathUtilService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'schema': [{ type: Input },],
'value': [{ type: Input },],
'path': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
